import { makeAutoObservable } from "mobx";

import { LocalStorageKeys } from "@/shared/constants/local-storage-keys";
import { Abilities, AbilityType } from "@/shared/types/abilities-types";
import { checkAbility, checkParty } from "@/shared/utils/check-abilities";
import { getFromLocalStorage } from "@/shared/utils/local-storage/get-from-local-storage";

export class AbilitiesStore {
	private _partyUUID: string | null = null;

	constructor() {
		makeAutoObservable(this);
	}

	get abilities(): Abilities {
		const jsonAbilities = getFromLocalStorage(LocalStorageKeys.Abilities);

		if (jsonAbilities) {
			return JSON.parse(jsonAbilities) as Abilities;
		}

		return {};
	}

	get partyUUID() {
		return this._partyUUID;
	}

	setPartyUUID = (partyUUID: string | null) => {
		this._partyUUID = partyUUID;
	};

	resetPartyUUID = () => {
		this._partyUUID = null;
	};

	checkMainLayerAbility = (ability: AbilityType) => checkAbility(this.abilities, ability);

	checkPartyLayerAbility = (partyUUID: string, ability: AbilityType) =>
		checkParty(this.abilities, ability, partyUUID);

	hasAbility = (ability: AbilityType) => {
		const isPartyLayer = !!this._partyUUID;

		if (!isPartyLayer) return checkAbility(this.abilities, ability);

		if (!this._partyUUID) {
			return false;
		}

		return checkParty(this.abilities, ability, this._partyUUID);
	};
}
